<template>
  <div class="topNav" style="-webkit-app-region: drag;">

    <img :src="global.ip + $store.state.logoImg" alt />
    <div class="line"></div>
    <span>{{$store.state.sysTitle}}</span>
    <span class="hint">{{ $store.state.greet }}</span>
    <div class="icon" style="-webkit-app-region: no-drag;">
      <img src="../assets/img/home/shr.png" alt @click="gosmall()" />
      <img src="../assets/img/home/amp.png" alt @click="scaleSys()" />
      <img src="../assets/img/home/cha.png" alt @click="offSys()" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: JSON.parse(localStorage.getItem("userinfo")),
      job: ["用户", "管理员", "超级管理员", "专家"],
    };
  },
  methods: {
    offSys() {
      this.$popup({
        title: '提示',
        content: '确定要退出本系统？',
        saveFoo: () => {
          if ('FingerprintObj' in window) {
            FingerprintObj.closeWindow()
          } else {
            this.$myMessage('当前状态下，没有此功能！')
          }
        },
      })
    },
    scaleSys() {
      if ('FingerprintObj' in window) {
        FingerprintObj.min_max_click()
      } else {
        this.$myMessage('当前状态下，没有此功能！')
      }
    },
    gosmall() {
      if ('FingerprintObj' in window) {
        FingerprintObj.setMinSize()
      } else {
        this.$myMessage('当前状态下，没有此功能！')
      }
    },
  },
};
</script>

<style scoped lang="less">
.topNav {
  height: 40px;
  background: #322ce7;
  display: flex;
  align-items: center;
  >img {
    // width: 56px;
    height: 24px;
    margin-left: 13px;
  }
  .line {
    height: 20px;
    border-left: 1px solid #fff;
    margin: 0 12px 0 10px;
  }
  span {
    color: #fff;
  }
  .hint {
    font-size: 14px;
    margin-left: 18px;
  }
  .icon {
    margin-left: auto;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }
  }
}
</style>
